import { render, staticRenderFns } from "./FlexmessageImageAction.vue?vue&type=template&id=214dc0ca&scoped=true&"
import script from "./FlexmessageImageAction.vue?vue&type=script&lang=js&"
export * from "./FlexmessageImageAction.vue?vue&type=script&lang=js&"
import style0 from "./FlexmessageImageAction.vue?vue&type=style&index=0&id=214dc0ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "214dc0ca",
  null
  
)

export default component.exports